export const UPDATE_PAGE_CARD = 'REPORTING_UPDATE_PAGE_CARD';

export const updatePageCard = content => ({
  type: UPDATE_PAGE_CARD,
  content,
});
